import curd from '../curd'

const BASE_PATH = '/site/config'

export default curd(BASE_PATH, {
  reserve: mn => ({
    url: `${BASE_PATH}/reserve/${mn}`,
    method: 'POST'
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/EnvConfig.js